/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Select} from 'antd';
import React from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../../../../assets/yearCalender.svg';
import {yearKeyLabel} from '../../../../../components/Forms/Constants/IP/commonKeyLabel';
import {
  OwnerShipKey,
  OwnerShipLabel
} from '../../../../../components/Forms/Constants/IP/OwnerShipKeyLabel';
import PercentageSlider from '../../../../../components/PercentageSlider/PercentageSlider';
import {CommonErrors} from '../../../../../constants/Common';
import InformativeText from '../../../../../constants/InformativeText';
import NumberInput from '../../../../../shared/NumberInput';
import useCompanyStore from '../../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../../utils/commonFunctions';
import RegEx from '../../../../../utils/FormUtils/RegEx';
import {yearSelect} from '../../../../../utils/FormUtils/yearSelect';
import {OPKey, OPLabel} from '../constants/orgProfileKeyLabel';

const BusinessDetailsForm: React.FC<{currentStep?: number}> = ({
  currentStep
}) => {
  const GDInfo = InformativeText?.OM;
  const {area, currency} = useCompanyStore.getState().preUnits;
  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();

  const colSpan = 24;

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={checkCurrentYearOrBelow(
                searchParam.get('selectedYear')
              )}
            >
              <Select
                placeholder={`Choose ${yearKeyLabel.label}`}
                options={yearFilter}
                suffixIcon={<YearCalender />}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={OPKey.TOTAL_FLOOR_SPACE}
              label={OPLabel.TOTAL_FLOOR_SPACE}
              style={{width: '100%'}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.TOTAL_FLOOR_SPACE)
                },
                {
                  pattern: RegEx.twoDigitDecimal,
                  message: CommonErrors.twoDigitPositive
                }
              ]}
              validateFirst={true}
              hasFeedback
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: GDInfo?.total_floor_space
              }}
            >
              <NumberInput
                addonAfter={area}
                placeholder={`Enter ${OPLabel.TOTAL_FLOOR_SPACE}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={OPKey.TOTAL_EMP}
              label={OPLabel.TOTAL_EMP}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.TOTAL_EMP)
                },
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              validateFirst={true}
              hasFeedback
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: GDInfo?.total_no_of_employee
              }}
            >
              <NumberInput placeholder={`Enter ${OPLabel.TOTAL_EMP}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={OPKey.FLEET_NUM}
              label={OPLabel.FLEET_NUM}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.FLEET_NUM)
                },
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              validateFirst={true}
              hasFeedback
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: GDInfo?.total_no_of_vehicle
              }}
            >
              <NumberInput placeholder={`Enter ${OPLabel.FLEET_NUM}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={OPKey.TOTAL_REVENUE}
              label={OPLabel.TOTAL_REVENUE}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.TOTAL_REVENUE)
                },
                {
                  pattern: RegEx.twoDigitDecimal,
                  message: CommonErrors.twoDigitPositive
                }
              ]}
              validateFirst={true}
              hasFeedback
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: GDInfo?.total_revenue
              }}
            >
              <NumberInput
                addonBefore={currency}
                placeholder={`Enter ${OPLabel.TOTAL_REVENUE}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <PercentageSlider
              fieldKey={OwnerShipKey.EQUITY_SHARES}
              fieldLabel={`${OwnerShipLabel.EQUITY_SHARES} (%)`}
              tooltipTitle={InformativeText.Ownership.equityShare}
              initialValue={null}
            />
          </Col>
          <Col className="gutter-row">
            <PercentageSlider
              fieldKey={OwnerShipKey.OP_CONTROL}
              fieldLabel={`${OwnerShipLabel.OP_CONTROL} (%)`}
              tooltipTitle={InformativeText.Ownership.OC}
              initialValue={null}
            />
          </Col>
          <Col className="gutter-row">
            <PercentageSlider
              fieldKey={OwnerShipKey.FIN_CONTROL}
              fieldLabel={`${OwnerShipLabel.FIN_CONTROL} (%)`}
              tooltipTitle={InformativeText.Ownership.FC}
              initialValue={null}
            />
          </Col>
        </>
      )}
    </>
  );
};

export default BusinessDetailsForm;
